import React from 'react';
import InputPrefix from '../../../components/connectedForm/InputPrefix';
import InputBlock from '../../../components/connectedForm/InputBlock';
import InputGroup from '../../../components/connectedForm/InputGroup';
import InputLabel from '../../../components/connectedForm/InputLabel';
import InputErrorMessage from '../../../components/connectedForm/InputErrorMessage';
import { ColorChangeHandler, ColorResult, TwitterPicker } from 'react-color';
import { Classes } from 'reactcss';
import { TwitterPickerStylesProps } from 'react-color/lib/components/twitter/Twitter';
import { merge } from 'lodash';

const foreColours: Array<string> = ['#ffffff', '#efefef', '#797775', '#000000'];

const colours: Array<string> = [
  '#ffffff',
  '#1a237e',
  '#45439c',
  '#000051',
  '#DD7596',
  '#700353',
  '#9A031E',
  '#2F1435',
  '#DB504A',
  '#ECA400',
  '#F18805',
  '#D95D39',
  '#00B9AF',
  '#136F63',
  '#006DAA',
  '#3E92CC',
];

export type IColourPickerProps = {
  active?: boolean;
  id?: string;
  label?: string;
  includeLabel?: boolean;
  inputPrefix?: any;
  flexBox?: any;
  labelCols?: number;
  inputCols?: number;
  readOnly?: boolean;
  hint?: string;
  validationErrors?: any;
  showWhenNotActive?: boolean;
  touched?: boolean;
  customValidationErrors?: any;
  mandatory?: boolean;
  onChange: (newValue: any) => void;
  backgroundColor?: string;
  colourSet?: 'foreground'; //Use a predefined set of colours (Note - 'colours' prop will override this, so only one of them needs to be provided).
  colours?: Array<string>;
  value?: `#${string}`;
  'data-testid'?: string;
  styles?: {
    picker?: Partial<Classes<TwitterPickerStylesProps>>;
  };
};

const ColourPicker = ({
  active,
  id,
  label,
  includeLabel,
  inputPrefix,
  flexBox,
  labelCols,
  inputCols,
  readOnly,
  hint,
  validationErrors,
  showWhenNotActive,
  touched,
  customValidationErrors,
  mandatory,
  onChange,
  colours: overrideColours,
  colourSet,
  backgroundColor = '#f8f8f8',
  'data-testid': dataTestId,
  value,
  styles,
}: IColourPickerProps) => {
  const handleChange: ColorChangeHandler = (newColour: ColorResult) => {
    onChange(newColour.hex);
  };

  const labelProps = {
    flexBox,
    id,
    includeLabel,
    hint,
    label,
    mandatory,
    readOnly,
  };

  const twitterPickerStyle: Partial<Classes<TwitterPickerStylesProps>> = merge(
    {
      default: {
        card: {
          background: backgroundColor || '#f8f8f8',
        },
      },
    },
    styles?.picker ?? {}
  );

  return (
    <InputBlock flexBox={flexBox}>
      <InputLabel {...labelProps} cols={labelCols} />
      <InputGroup
        flexBox={flexBox}
        cols={includeLabel ? inputCols : 1}
        withLabel={includeLabel}
        data-testid={dataTestId}
      >
        <InputPrefix inputPrefix={inputPrefix} />
        <TwitterPicker
          onChange={handleChange}
          colors={overrideColours || (colourSet === 'foreground' ? foreColours : colours)}
          styles={twitterPickerStyle}
          triangle={'hide'}
          width={'325'}
          color={value || '#000000'}
        />
        <InputErrorMessage
          label={label}
          active={active}
          touched={touched}
          validationErrors={validationErrors}
          showWhenNotActive={showWhenNotActive}
          customValidationErrors={customValidationErrors}
        />
      </InputGroup>
    </InputBlock>
  );
};

export default ColourPicker;
